// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyBQW5OReuEByzUI_ICpLhC5XF4dIPTQS5I",
  authDomain: "chopmyshop.firebaseapp.com",
  projectId: "chopmyshop",
  storageBucket: "chopmyshop.firebasestorage.app",
  messagingSenderId: "941157104060",
  appId: "1:941157104060:web:67f37c0eca4db8e66793b9",
  measurementId: "G-RFSMJNJM26"
};

// Anthropic API key for Penny
export const ANTHROPIC_API_KEY = "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";